define([
  "backbone",
  "jquery",
  "marionette",
  "messaging/messenger",
  "./tenantUsersView",
  "modules/admin/userAdministration/userList/userListModule",
  "modules/admin/userAdministration/userDetails/userDetailsModalModule",
  "modules/admin/userAdministration/usersModel",
  "modules/admin/userAdministration/userStatusFilter/userStatusFilterModule",
], function (
  Backbone,
  $,
  Marionette,
  Messenger,
  TenantUsersView,
  UserListModule,
  UserDetailsModalModule,
  UsersModel,
  UserStatusFilterModule,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "tenantUsers";
      this.region = options.region;
      this.tenant = options.model;
      this._setUpVents();
    },
    show: function () {
      // Must be of type UsersModel.allUsers or similar, implementing addNewUser()
      this.tenantUsers = Messenger.reqres.request("tenant:users", this.tenant.get("tenantId"));

      this.view = new TenantUsersView.tenantUsersView();
      this.tenantUsersList = this.addSubModule(
        new UserListModule({
          region: this.view.tenantUsersList,
          namespace: "tenantUsers",
        }),
      );
      this.tenantUserStatusFilter = this.addSubModule(
        new UserStatusFilterModule({
          region: this.view.tenantUserStatusFilter,
          namespace: "tenantUsers",
        }),
      );

      this.view.on("add:user", this._addUser, this);

      this.view.on(
        "show",
        function () {
          this._showSubViews();
        },
        this,
      );

      this.showRegion(this.view);
    },
    _addUser: function () {
      const user = this.tenantUsers.addNewUser();
      user.set("tenantId", this.tenant.get("tenantId"));
      user.set("showPassword", true);
      Messenger.vent.trigger(
        "show:modal",
        UserDetailsModalModule,
        {
          editMode: false,
        },
        user,
        {
          title: $.t("admin.userAdministration.addUser"),
          closeButton: false,
          closeOnBackgroundClick: false,
          modalWidth: "900px",
          trackInteraction: {
            action: "Add Tenant User",
            object: "User",
          },
        },
      );
    },
    _showSubViews: function () {
      this.tenantUsers.onSynced(function () {
        this.tenantUsersList.show(this.tenantUsers);
        this.tenantUserStatusFilter.show(this.tenantUsers);
      }, this);
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "show:tenant:profile:users",
        function (userId) {
          this.show();
          if (userId) {
            if (userId == "new") {
              Backbone.history.navigate(
                "accountAdmin/tenants/" + this.tenant.get("tenantId") + "/users/new",
              );
              this._addUser();
              return;
            }
            userId = +userId;
            if (userId && !isNaN(userId)) {
              this.tenantUsers.onSynced(function () {
                const user = this.tenantUsers.get(userId);
                if (user) {
                  Backbone.history.navigate(
                    "accountAdmin/tenants/" + this.tenant.get("tenantId") + "/users/" + userId,
                  );
                  this._showUser(user);
                }
              }, this);
            }
          }
          Backbone.history.navigate(
            "accountAdmin/tenants/" + this.tenant.get("tenantId") + "/users",
          );
        },
        this,
      );
    },
    _showUser: function (model) {
      Messenger.vent.trigger(
        "show:modal",
        UserDetailsModalModule,
        {
          editMode: true,
        },
        model,
        {
          title: $.t("admin.userAdministration.editUser"),
          closeButton: false,
          closeOnBackgroundClick: false,
          modalWidth: "900px",
          trackInteraction: {
            action: "Edit Tenant User",
            id: model.id,
            idType: "User",
            object: "User",
          },
        },
      );
    },
  });
});
